import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import EditOrCreate from './Form/EditOrCreate';
import useColumnDefinitions from './hooks/useColumnDefinitions';
import useGetAuxiliaryValues from './hooks/useGetAuxiliaryValues';
import { FilterComponent } from '../Settings/AdminFunctions/filter/FilterComponent';
import { useEffect, useState } from 'react';
import { pipe } from 'ramda';

import type { AuxValue } from 'RestAPIs/AuxiliaryValues';
import type { Filters } from 'components/admin-portal/Tables/Settings/AdminFunctions/filter/FilterComponent.types';

const AuxiliaryValues = () => {
  'use memo';

  const { data, isFetching, isError, refetch } = useGetAuxiliaryValues();
  const [filteredRows, setFilteredRows] = useState<AuxValue[] | undefined>();
  const columnDefinitions = useColumnDefinitions();

  useEffect(() => {
    setFilteredRows(data);
  }, [data]);

  const filterBySearch = (data: AuxValue[], search: string | null) => {
    if (search === null) return data;

    return data.filter(
      (item) =>
        item.code?.toLowerCase().includes(search.toLowerCase()) ||
        item.auxValueGroupName?.toLowerCase().includes(search.toLowerCase()) ||
        item.translations?.[0]?.name
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  };

  const handleFilterChange = async (filters: Filters) => {
    if (isFetching) return data;
    const { search } = filters;

    const filtered = await pipe((data) => filterBySearch(data, search))(data);

    setFilteredRows(filtered);
  };

  return (
    <>
      <FilterComponent handleFilterChange={handleFilterChange} />
      <TableCRUDLayout
        FormComponent={EditOrCreate}
        columns={columnDefinitions}
        rows={filteredRows}
        getRowId={(row) => row.auxValueId}
        loading={isFetching}
        hasLoadingError={isError}
        onLoadingError={refetch}
        initialState={{
          sorting: {
            sortModel: [
              { field: 'auxValueGroupId', sort: 'asc' },
              { field: 'code', sort: 'asc' }
            ]
          }
        }}
      />
    </>
  );
};

export default AuxiliaryValues;
